import React, { useState } from 'react';
import { X } from 'lucide-react';
function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={onClose} data-id="element-153">
      <div className="fixed inset-0 bg-black/60 backdrop-blur-sm" data-id="element-154" />
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[85vh] flex flex-col z-10" onClick={e => e.stopPropagation()} data-id="element-155">
        <div className="flex items-center justify-between p-6 border-b border-gray-200 flex-shrink-0" data-id="element-156">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-157">{title}</h2>
          <button onClick={onClose} className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center hover:bg-gray-200 transition-colors" data-id="element-158">
            <X className="w-5 h-5 text-gray-600" data-id="element-159" />
          </button>
        </div>
        <div className="p-6 overflow-y-auto text-gray-700 text-sm leading-relaxed space-y-4" data-id="element-160">
          {children}
        </div>
      </div>
    </div>;
}
export function FooterSection() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  return <>
      <footer className="bg-gray-950 py-8 px-4" data-id="element-161">
        <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-162">
          <p className="text-xs text-gray-500" data-id="element-163">
            © {new Date().getFullYear()} El Código del Azúcar en Sangre. Todos
            los derechos reservados.
          </p>
          <div className="flex items-center gap-6" data-id="element-164">
            <button onClick={() => setShowTerms(true)} className="text-xs text-gray-400 hover:text-white transition-colors underline underline-offset-2" data-id="element-165">
              Términos y Condiciones
            </button>
            <button onClick={() => setShowPrivacy(true)} className="text-xs text-gray-400 hover:text-white transition-colors underline underline-offset-2" data-id="element-166">
              Política de Privacidad
            </button>
          </div>
        </div>
      </footer>

      {/* Modal: Términos y Condiciones */}
      <LegalModal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-167">
        <p className="font-bold text-gray-900" data-id="element-168">
          Última actualización: marzo 2026
        </p>

        <p data-id="element-169">
          Al acceder y adquirir el producto digital "El Código del Azúcar en
          Sangre" (en adelante, "el eBook"), aceptas los siguientes términos y
          condiciones de uso. Te recomendamos leerlos detenidamente antes de
          realizar tu compra.
        </p>

        <h3 className="font-bold text-gray-900 text-base mt-4" data-id="element-170">
          1. Naturaleza del Producto
        </h3>
        <p data-id="element-171">
          El eBook es un producto digital en formato PDF descargable. Su
          contenido es estrictamente educativo e informativo. No constituye
          asesoramiento médico, nutricional ni profesional de ningún tipo.
        </p>

        <h3 className="font-bold text-gray-900 text-base mt-4" data-id="element-172">
          2. Uso Personal
        </h3>
        <p data-id="element-173">
          La compra del eBook otorga una licencia personal, intransferible y no
          exclusiva para su uso. Queda prohibida la reproducción, distribución,
          reventa, copia o difusión total o parcial del contenido sin
          autorización expresa por escrito.
        </p>

        <h3 className="font-bold text-gray-900 text-base mt-4" data-id="element-174">
          3. Entrega del Producto
        </h3>
        <p data-id="element-175">
          Una vez procesado el pago, recibirás acceso inmediato al enlace de
          descarga del eBook. También se enviará una copia del enlace al correo
          electrónico proporcionado durante la compra. Es tu responsabilidad
          asegurarte de que la dirección de correo sea correcta.
        </p>

        <h3 className="font-bold text-gray-900 text-base mt-4" data-id="element-176">
          4. Política de Reembolso
        </h3>
        <p data-id="element-177">
          Ofrecemos una garantía de satisfacción de 30 días naturales a partir
          de la fecha de compra. Si no estás satisfecho con el producto, puedes
          solicitar un reembolso completo dentro de ese plazo. La solicitud debe
          realizarse por correo electrónico. No se requiere justificación.
        </p>

        <h3 className="font-bold text-gray-900 text-base mt-4" data-id="element-178">
          5. Descargo de Responsabilidad
        </h3>
        <p data-id="element-179">
          Los resultados descritos en el material de venta y dentro del eBook
          son ejemplos y no garantizan resultados específicos. Cada persona es
          diferente y los resultados dependen de factores individuales como el
          estado de salud, la constancia y el compromiso personal.
        </p>

        <h3 className="font-bold text-gray-900 text-base mt-4" data-id="element-180">
          6. Consulta Médica
        </h3>
        <p data-id="element-181">
          Antes de realizar cualquier cambio significativo en tu alimentación o
          estilo de vida, especialmente si padeces diabetes, prediabetes u otra
          condición médica, debes consultar a un profesional de la salud
          calificado.
        </p>

        <h3 className="font-bold text-gray-900 text-base mt-4" data-id="element-182">
          7. Propiedad Intelectual
        </h3>
        <p data-id="element-183">
          Todo el contenido del eBook, incluyendo textos, gráficos,
          ilustraciones y diseño, está protegido por derechos de autor.
          Cualquier uso no autorizado será considerado una violación de estos
          derechos.
        </p>

        <h3 className="font-bold text-gray-900 text-base mt-4" data-id="element-184">
          8. Modificaciones
        </h3>
        <p data-id="element-185">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones entrarán en vigor desde su publicación. El
          uso continuado del producto implica la aceptación de los términos
          actualizados.
        </p>

        <h3 className="font-bold text-gray-900 text-base mt-4" data-id="element-186">
          9. Ley Aplicable
        </h3>
        <p data-id="element-187">
          Estos términos se rigen por las leyes aplicables en la jurisdicción
          correspondiente. Cualquier disputa será resuelta mediante los
          mecanismos legales disponibles en dicha jurisdicción.
        </p>
      </LegalModal>

      {/* Modal: Política de Privacidad */}
      <LegalModal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-188">
        <p className="font-bold text-gray-900" data-id="element-189">
          Última actualización: marzo 2026
        </p>

        <p data-id="element-190">
          Tu privacidad es importante para nosotros. Esta política describe qué
          información recopilamos, cómo la usamos y cómo la protegemos cuando
          adquieres "El Código del Azúcar en Sangre".
        </p>

        <h3 className="font-bold text-gray-900 text-base mt-4" data-id="element-191">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-192">
          Al realizar tu compra, recopilamos únicamente la información necesaria
          para procesar la transacción y entregar el producto:
        </p>
        <ul className="list-disc pl-6 space-y-1" data-id="element-193">
          <li data-id="element-194">Nombre completo</li>
          <li data-id="element-195">Dirección de correo electrónico</li>
          <li data-id="element-196">
            Información de pago (procesada de forma segura por nuestro proveedor
            de pagos)
          </li>
        </ul>

        <h3 className="font-bold text-gray-900 text-base mt-4" data-id="element-197">
          2. Uso de la Información
        </h3>
        <p data-id="element-198">La información recopilada se utiliza exclusivamente para:</p>
        <ul className="list-disc pl-6 space-y-1" data-id="element-199">
          <li data-id="element-200">Procesar y confirmar tu compra</li>
          <li data-id="element-201">Enviar el enlace de descarga del eBook</li>
          <li data-id="element-202">
            Comunicarnos contigo en caso de ser necesario respecto a tu compra
          </li>
          <li data-id="element-203">
            Enviar información relevante sobre el producto, solo si has dado tu
            consentimiento
          </li>
        </ul>

        <h3 className="font-bold text-gray-900 text-base mt-4" data-id="element-204">
          3. Protección de Datos
        </h3>
        <p data-id="element-205">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger tu información personal contra acceso no autorizado, pérdida
          o alteración. Tu información de pago es procesada directamente por
          proveedores de pago certificados y nunca almacenamos datos de tarjetas
          de crédito en nuestros servidores.
        </p>

        <h3 className="font-bold text-gray-900 text-base mt-4" data-id="element-206">
          4. Compartir Información
        </h3>
        <p data-id="element-207">
          No vendemos, alquilamos ni compartimos tu información personal con
          terceros, excepto cuando sea necesario para procesar tu compra a
          través de nuestros proveedores de servicios de pago.
        </p>

        <h3 className="font-bold text-gray-900 text-base mt-4" data-id="element-208">5. Cookies</h3>
        <p data-id="element-209">
          Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
          navegación y analizar el tráfico del sitio. Puedes configurar tu
          navegador para rechazar cookies, aunque esto podría afectar algunas
          funcionalidades.
        </p>

        <h3 className="font-bold text-gray-900 text-base mt-4" data-id="element-210">
          6. Tus Derechos
        </h3>
        <p data-id="element-211">Tienes derecho a:</p>
        <ul className="list-disc pl-6 space-y-1" data-id="element-212">
          <li data-id="element-213">Acceder a la información personal que tenemos sobre ti</li>
          <li data-id="element-214">Solicitar la corrección de datos inexactos</li>
          <li data-id="element-215">Solicitar la eliminación de tus datos personales</li>
          <li data-id="element-216">
            Retirar tu consentimiento para comunicaciones en cualquier momento
          </li>
        </ul>

        <h3 className="font-bold text-gray-900 text-base mt-4" data-id="element-217">
          7. Retención de Datos
        </h3>
        <p data-id="element-218">
          Conservamos tu información personal únicamente durante el tiempo
          necesario para cumplir con los fines descritos en esta política, o
          según lo requieran las obligaciones legales aplicables.
        </p>

        <h3 className="font-bold text-gray-900 text-base mt-4" data-id="element-219">
          8. Menores de Edad
        </h3>
        <p data-id="element-220">
          Este producto está dirigido a personas mayores de 18 años. No
          recopilamos intencionalmente información de menores de edad.
        </p>

        <h3 className="font-bold text-gray-900 text-base mt-4" data-id="element-221">
          9. Cambios en esta Política
        </h3>
        <p data-id="element-222">
          Nos reservamos el derecho de actualizar esta política de privacidad en
          cualquier momento. Cualquier cambio será publicado en esta página con
          la fecha de actualización correspondiente.
        </p>
      </LegalModal>
    </>;
}